import {
  FETCH_ALL_F2F_PERFORMERS_START,
  FETCH_ALL_F2F_PERFORMERS_SUCCESS,
  FETCH_ALL_F2F_PERFORMERS_FAILURE,
  FACE_2_FACE_SEND_TIP,
  FACE_2_FACE_SEND_TIP_SUCCESS,
  FACE_2_FACE_SEND_TIP_FAILURE
} from '../actions/ActionConstant';
import { appendF2FPerformers } from '../../helpers/array/array'

const initialState = {
  allPerformers: {
    data: {
      performers: [],
      pagination: {}
    },
    loading: false,
    error: null,
  },
  allOnlinePerformer: {
    data: [],
    loading: false,
    error: null,
  },
  f2fTipWallet: {
    data: {},
    loading: false,
    error: false,
  }
};

const StreamingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_F2F_PERFORMERS_START:
      return {
        ...state,
        allPerformers: {
          ...state.allPerformers,
          error: false,
          loading: true,
        },
      };
    case FETCH_ALL_F2F_PERFORMERS_SUCCESS:
      return {
        ...state,
        allPerformers: {
          data: {
            performers: appendF2FPerformers(state.allPerformers?.data?.performers || [], action?.data),
            pagination: action?.data?.pagination
          },
          error: false,
          loading: false,
        },
      };
    case FETCH_ALL_F2F_PERFORMERS_FAILURE:
      return {
        ...state,
        allPerformers: {
          ...state.allPerformers,
          error: action.data,
          loading: false,
        },
      };

    case FACE_2_FACE_SEND_TIP:
      return {
        ...state,
        f2fTipWallet: {
          data: {},
          loading: true,
          error: false,
        },
      };
    case FACE_2_FACE_SEND_TIP_SUCCESS:
      return {
        ...state,
        f2fTipWallet: {
          data: action.data,
          loading: false,
          error: false,
        },
      };
    case FACE_2_FACE_SEND_TIP_FAILURE:
      return {
        ...state,
        f2fTipWallet: {
          data: action.data,
          loading: false,
          error: true,
        },
      };
      
    default:
      return state;
  }
};

export default StreamingReducer;
